"use strict";

exports.__esModule = true;
exports.default = pick;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key]; // eslint-disable-line
    }
    return result;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/google-map-react/lib/utils/pick.js
// module id = 928
// module chunks = 186072240823722